var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","height":"100%"}},[_c('router-view'),_c('audio',{attrs:{"id":"myAudio","src":require('@/assets/mp3/jb.mp3'),"loop":_vm.loop}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }